// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__Ty3ee","title":"Hero_title__KJMhH"};